<template>
  <div class="content">
    <l-table
      ref="table"
      :tableConfig="tableConfig"
      :searchParams="searchParams"
      @tableChange="handleTableChange"
      emptyText="暂无数据"
      :emptyImgSrc="emptyImgSrc"
      :showCreateBtn="true"
    >
      <template slot="searchConditions">
        <div class="search-box">
          <div class="search">
            <a-input v-model="searchParams.keyword" placeholder="请输入知识库名称">
              <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
              <img
                class="clear"
                v-if="searchParams.keyword"
                slot="suffix"
                @click="searchParams.keyword = undefined"
                :src="require('@/assets/icons/icon_gb.png')"
              />
            </a-input>
            <div class="search_text"><span></span>搜索</div>
          </div>
          <div class="times">
            <a-range-picker
              v-model="dateRange"
              format="YYYY-MM-DD"
              :placeholder="['开始时间', '结束时间']"
              @change="onChange"
            />
          </div>
        </div>
      </template>
      <template #searchActions>
        <a-button type="primary" @click="create">新建知识库</a-button>
      </template>
      <template #description="{ record }">
        <a-tooltip>
          <template slot="title">
            <span>{{ record.description }}</span>
          </template>
          <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; ">
            {{ record.description.slice(0, 30) }} <span v-if="record.description.length > 30">...</span>
          </div>
        </a-tooltip>
      </template>
      <template #permission="{ record }">
        <span>{{ record.permission === '1' ? '个人' : '学院' }}</span>
      </template>
      <template #status="{ record }">
        <a-switch
          style="min-width:40px"
          :disabled="!isAdmin"
          :checked="record.status === '1'"
          @change="changeStatus(record)"
        />
      </template>
      <template #operates="{ record }">
        <div class="operates">
          <a-tooltip placement="top">
            <template slot="title">
              <span>查看</span>
            </template>
            <img src="@/assets/icons/ai_history_view.png" @click="viewDetails(record.id)" />
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>编辑</span>
            </template>
            <img src="@/assets/icons/ai_history_edit.png" @click="edit(record)" />
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>删除</span>
            </template>
            <img src="@/assets/icons/ai_history_delete.png" @click="delModal(record.id)" />
          </a-tooltip>
        </div>
      </template>
      <template #create>
        <a-button type="primary" @click="create">新建知识库</a-button>
      </template>
      <template #serchTip>
        <p>{{ dateRange && dateRange.length > 0 ? '请换一个时间段吧~' : '请换一个搜索词吧~' }}</p>
      </template>
    </l-table>
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="
        `
        <p>${tableConfig.tableDeleteTip && tableConfig.tableDeleteTip.title}</p>
        <p class='placeholder'>${tableConfig.tableDeleteTip && tableConfig.tableDeleteTip.content}</p>`
      "
    />
  </div>
</template>

<script>
import jsCookie from 'js-cookie'
import LTable from '@/components/LTable/index.vue'
import TipModal from '@/components/tipModal/index.vue'
import { classMap, ticket, portalExperimentDetail, uploadExperimentReport } from '@/api/experiment'
import Upload from '@/components/upload/index.vue'
import { setKnowledgeBaseStatus, deleteDataset } from '@/api/ai.js'

const userType = JSON.parse(jsCookie.get('user_type')).join(',')
const data = []
export default {
  components: {
    LTable,
    TipModal,
    Upload
  },
  data() {
    return {
      searchParams: {
        keyword: undefined,
        startTime: '',
        endTime: ''
      },
      tableConfig: {
        tableName: '',
        tableColumns: [
          {
            title: '知识库名称',
            dataIndex: 'name',
            key: 'name',
            align: 'center'
          },
          {
            title: '描述',
            dataIndex: 'description',
            key: 'description',
            align: 'center',
            scopedSlots: { customRender: 'description' }
          },
          {
            title: '文档',
            dataIndex: 'documentCount',
            key: 'documentCount',
            align: 'center'
          },
          {
            title: '归属',
            dataIndex: 'permission',
            key: 'permission',
            align: 'center',
            customSlots: true,
            scopedSlots: { customRender: 'permission' },
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: '个人', value: '1' },
              { text: '学院', value: '2' }
            ]
          },
          {
            title: '编辑时间',
            dataIndex: 'updateTime',
            key: 'updateTime',
            align: 'center',
            width: 180,
            sorter: () => {},
          },
          {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 100,
            customSlots: true,
            scopedSlots: { customRender: 'status' },
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: '开启', value: '1' },
              { text: '关闭', value: '2' }
            ]
          },
          {
            title: '操作',
            width: 180,
            dataIndex: 'operates',
            key: 'operates',
            align: 'center',
            customSlots: true,
            scopedSlots: { customRender: 'operates' }
          }
        ],
        tableDeleteTip: {
          title: '确定要删除该知识库？',
          content: '知识库删除后无法找回'
        },
        tablePort: {
          list: '/ai/dataset/list',
          del: '/ai/dataset/delete'
        },
        tableData: data
      },
      delVisible: false,
      delId: '',
      userType,
      emptyImgSrc: require('@/assets/img/pic_zhishiku@2x.png'),
      uploadVisible: false,
      uploading: false,
      fileList: [],
      currentRecord: null,
      dateRange: null,
      isAdmin: false
    }
  },
  watch: {
    dateRange(val) {
      if (val.length === 2) {
        this.searchParams.startTime = val[0].startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.searchParams.endTime = val[1].endOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchParams.startTime = ''
        this.searchParams.endTime = ''
      }
    }
  },
  methods: {
    onChange() {
      this.searchParams.startTime = this.dateRange[0]
        ? this.dateRange[0].startOf('day').format('YYYY-MM-DD HH:mm:ss')
        : ''
      this.searchParams.endTime = this.dateRange[1] ? this.dateRange[1].endOf('day').format('YYYY-MM-DD HH:mm:ss') : ''
    },
    create() {
      this.$router.push({
        name: 'addRepository'
      })
    },
    edit(record) {
      if (!this.isAdmin) return
      this.$router.push({
        name: 'addRepository',
        query: {
          id: record.id
        }
      })
    },
    del() {
      deleteDataset({ id: this.delId }).then(res => {
        if (res.code === 200) {
          this.delVisible = false
          this.$message.success('删除成功！')
          this.$refs.table.getList()
        }
      })
    },
    delModal(id) {
      if (!this.isAdmin) return
      this.delVisible = true
      this.delId = id
    },
    showUploadModal(record) {
      this.currentRecord = record
      const currentTime = new Date()
      this.pathname =
        'school-level-platform/' +
        currentTime.getFullYear() +
        (currentTime.getMonth() + 1) +
        currentTime.getDate() +
        '/' +
        new Date().getTime().toString() +
        '.pdf'
      this.uploadVisible = true
      this.fileList = []
    },
    async handleUploadSubmit() {
      if (this.fileList.length === 0) {
        this.$message.warning('请选择要上传的文件')
        return
      }
      this.uploading = true
      const res = await uploadExperimentReport({
        id: this.currentRecord.id,
        fileUrl: this.fileList[0].url,
        fileName: this.fileList[0].name
      })
      if (res.code === 200) {
        this.$message.success('提交成功')
        this.uploadVisible = false
        this.$refs.table.getList()
      }
    },
    uploadData(data) {
      this.fileList = data
    },
    viewDetails(id) {
      if (!this.isAdmin) return
      this.$router.push({ name: 'repositoryFileDetails', query: { id } })
    },
    toExamine() {
      // this.$router.push({ name: 'experimentCheckExamine' })
    },
    handleTableChange([filters, getList, sort]) {
      const result = {}
      for (const key in filters) {
        if (filters[key]) {
          result[key] = filters[key].length > 1 ? '' : filters[key][0]
        }
      }
      getList({ condition: { ...result, sortRule: sort.order === 'ascend' ? 'asc' : 'desc' } })
    },
    getClass(id) {
      const curClass = this.classList.find(item => {
        return item.id === id
      })
      return curClass?.name ? curClass.name : '未知'
    },
    async goCheck(id, examineId) {
      const ticketRes = await ticket()
      const detaisRes = await portalExperimentDetail({ id: examineId })
      window.open(`${detaisRes.data.url}?ticket=${ticketRes.data.ticket}&examine_id=${id}`)
      // { ticket: ticketRes.data, examine_id: id }
      console.log('detaisRes ----->', `${detaisRes.data.url}?ticket=${ticketRes.data.ticket}&examine_id=${id}`)
    },
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode
    },
    changeStatus(record) {
      setKnowledgeBaseStatus({
        id: record.id,
        status: record.status === '1' ? 2 : 1
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('状态已更新')
          this.$refs.table.getList()
        }
      })
    }
  },
  created() {
    classMap().then(res => {
      if (res.code !== 200) return
      this.classList = res.data.list
      this.$refs.table.getList()
    })
    const roles = JSON.parse(localStorage.roles)
    if (roles.includes('admin')) {
      this.isAdmin = true
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .operates {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 20px;
    height: auto;
    margin-right: 20px;
    cursor: pointer;
    &:last-child {
      margin-right: 0px;
    }
  }
}
.content {
  padding: 0px 19px;
  .search-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .search {
    width: 330px;
    position: relative;
    margin-right: 20px;
    .search_text {
      position: absolute;
      top: 6px;
      right: 20px;
      display: flex;
      z-index: 5;
      cursor: pointer;
      span {
        display: inline-block;
        width: 1px;
        height: 10px;
        background: #e9e9e9;
        margin-right: 8px;
        margin-top: 6px;
      }
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
    /deep/ .ant-input-affix-wrapper {
      width: 330px;
    }
    /deep/ .ant-input {
      width: 330px;
      height: 35px;
      color: #000;
      margin-right: 30px;
      border-radius: 20px;
      padding-right: 59px;
    }
    /deep/ .ant-input-suffix {
      right: 62px;
    }
  }
}
.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled:hover span {
  color: #384959;
}
.operate-icon {
  color: #6b738c;
  margin-right: 20px;
  font-size: 18px;
  cursor: pointer;
  &:hover {
    color: #ff6d00;
  }
  &:last-child {
    margin-right: 0;
  }
}
</style>
<style lang="less">
.l-dropdown-menu-btn {
  .action {
    border-radius: 20px;
    text-align: center;
    padding: 7px 10px;
    background-color: #f8f8f8;
  }
  .ant-dropdown-menu-item {
    width: 86px;
    height: 30px;
    display: flex;
    font-size: 12px;
    margin: 7px 8px;
    font-weight: 400;
    line-height: 17px;
    align-items: center;
    border-radius: 15px;
    background: #f8f8f8;
    //  !important;
    img {
      width: 12px !important;
      height: 12px;
      margin-right: 6px;
    }
    span {
      width: 100%;
      color: #384959;
      display: inline-block;
      text-align-last: justify;
    }
    &:hover span {
      color: #ff6d00;
    }
  }
}
</style>
